import React from 'react';
import {Button, CircularProgress, Divider, LinearProgress, Paper, withStyles} from "material-ui";
import {connect} from "react-redux";
import {
    closeGetCompaniesFetch,
    closeGetCompanyFetch,
    closePostCompanyFetch,
    closePutCompanyFetch,
    companyInit,
    getCompanies,
    getCompany,
    postCompany,
    putCompany
} from "../../redux/actions/companies";
import {CompanyForm} from "../../forms/company";
import {Companies} from "../../components/companies";
import {setActiveCompanyId} from "../../redux/actions/app";
import {snackMessageShow} from "../../redux/actions/snack_message";

export class ClientComponent extends React.Component {

    componentDidMount = () => {
        document.title = '顧客管理 | 三島事務所';
        this.props.companyInit();
        this.props.getCompanies();
    };

    onClickSubmitButton = (values) => {

        this.props.onClickSubmitButton(values, (response) => {

            switch (response.type) {
                case 'API_POST_COMPANY_SUCCESS':
                    this.props.getCompany(response.payload.data.id);
                    this.props.getCompanies();
                    break;

                case 'API_PUT_COMPANY_SUCCESS':
                    this.props.getCompanies();
                    break;
                default:
            }
        });
    };


    onCreateSubmit = () => {
        this.refs.createForm.submit();
    };

    onClickNewItem = () => {
        this.props.companyInit();
    };

    onCompanySelect = (company) => {
        this.props.getCompany(company.id);
    };

    render() {

        const {
            classes, company, errors,
            isGetCompanyFetch, isPostCompanyFetch, isPutCompanyFetch,
            activeCompanyId,
        } = this.props;

        return (
            <div className={classes.root}>

                <Companies
                    onClickNewItem={this.onClickNewItem}
                    onCompanySelect={this.onCompanySelect}
                    isNewItem={true}/>

                <Paper className={classes.mainContainer}>

                    <Paper>
                        <div className={classes.registerForm}>

                            {isGetCompanyFetch ? <CircularProgress/> :

                                <CompanyForm
                                    ref="createForm"
                                    errors={errors}
                                    onSubmit={this.onClickSubmitButton}
                                    initialValues={company}
                                    isAdmin={true}/>
                            }

                        </div>
                        <Divider/>
                        {!isGetCompanyFetch ?
                            <div className={classes.footer}>
                                <Button
                                    disabled={isPostCompanyFetch || isPutCompanyFetch}
                                    onClick={this.onCreateSubmit}
                                    color="primary">
                                    {activeCompanyId === -1 ? '新規登録' : 'アップデート'}
                                </Button>
                            </div> : null}
                        {isPostCompanyFetch || isPutCompanyFetch ? <LinearProgress/> : null}
                    </Paper>

                </Paper>
            </div>
        )
    }

}

const styles = theme => ({
    root: {
        display: 'flex',
        height: 'calc(100vh - 64px)',
        position: 'relative',
    },
    mainContainer: {
        background: '#fbfbfb',
        zIndex: 1,
        width: '100%',
        position: 'relative',
        overflow: 'auto',
        padding: theme.spacing.unit * 3,
    },
    registerForm: {
        padding: theme.spacing.unit * 3,
    },
    footer: {
        padding: theme.spacing.unit,
        textAlign: 'right',
    },
});

ClientComponent = withStyles(styles)(ClientComponent);

ClientComponent = connect(
    (state) => {
        return {
            company: state.companies.company,
            companies: state.companies.companies,
            isGetCompanyFetch: state.companies.isGetCompanyFetch,
            isGetCompaniesFetch: state.companies.isGetCompaniesFetch,
            isPostCompanyFetch: state.companies.isPostCompanyFetch,
            isPutCompanyFetch: state.companies.isPutCompanyFetch,
            errors: state.companies.errors,
            activeCompanyId: state.app.activeCompanyId,
        }
    },
    (dispatch) => {
        return {
            companyInit: () => {
                dispatch(companyInit());
                setTimeout(() => {
                    dispatch(closeGetCompanyFetch());
                }, 100);
            },
            onClickSubmitButton: (company, receive) => {
                if (company.id === undefined) {
                    dispatch(postCompany(company)).then((response) => {
                        dispatch(closePostCompanyFetch());
                        setTimeout(() => {
                            switch (response.type) {
                                case 'API_POST_COMPANY_SUCCESS':
                                    dispatch(snackMessageShow('新規顧客を作成しました'));
                                    dispatch(setActiveCompanyId(response.payload.data.id));
                                    receive(response);
                                    break;
                                default:
                                    dispatch(snackMessageShow('顧客情の作成に失敗しました'));
                            }
                        }, 100);
                    });
                } else {
                    dispatch(putCompany(company)).then((response) => {
                        setTimeout(() => {
                            dispatch(closePutCompanyFetch());
                            switch (response.type) {
                                case 'API_PUT_COMPANY_SUCCESS':
                                    dispatch(snackMessageShow('顧客情報を更新しました'));
                                    receive(response);
                                    break;
                                default:
                                    dispatch(snackMessageShow('顧客情の更新に失敗しました'));
                            }
                        }, 100);
                    });
                }
            },
            getCompanies: () => {
                dispatch(getCompanies())
                    .then(() => {
                        dispatch(closeGetCompaniesFetch());
                    });
            },
            getCompany: (companyId) => {
                dispatch(getCompany(companyId))
                    .then(() => {
                        setTimeout(() => {
                            dispatch(closeGetCompanyFetch());
                        }, 100);
                    });
            },
        }
    }
)(ClientComponent);


// WEBPACK FOOTER //
// ./src/containers/client/index.js